import { useMemo } from 'react'

import GridCard from './GridCard'
import GridCardSkeleton from './GridCardSkeleton'
import Button from '../../../Button'
import SubjectCreateButton from './SubjectCreateButton'
import { useMediaQuery } from 'react-responsive'

const GridsNavigation = ({
  removeGrid,
  gridsFromSubject,
  handleCurrentGrid,
  answer,
  currentGridIndex,
  handleNewSubjectWindow,
  isLoadingSubject,
  isSkippingSubject,
  create,
  onSuccessCreateSubject,
  allowHint,
  setAllowHint,
  handleCloseGridsModal,
  beginTimestamp = null,
  endTimestamp = null,
}) => {
  const sortedGrids = useMemo(
    () =>
      gridsFromSubject?.reduce((acc, grid, index) => {
        const course = grid.course
        if (!acc[course]) {
          acc[course] = []
        }
        acc[course].push({
          grid: grid,
          index: index,
        })
        return acc
      }, {}),
    [gridsFromSubject],
  )

  let globalIndex = 0
  const numberOfSkeletonCards = 10

  const isTablet = useMediaQuery({ query: '(max-width: 1280px)' })

  return (
    <div
      className={` mt-0 grow md:grow-[0] h-fit ${
        !isTablet && 'max-h-[calc(95svh-120px)]'
      } gap-5 flex-col justify-center items-center relative max-w-[300px] z-[10] rounded bg-transparent`}
    >
      {create && gridsFromSubject?.length === 0 ? (
        <div className="h-56 flex rounded bg-container-background justify-center items-center text-over-primary-background">
          Nicio grilă adaugată
        </div>
      ) : (
        <>
          <div
            className={`${
              !isTablet && 'max-h-[calc(95svh-120px)]'
            } flex flex-col gap-5 pr-[10px] rounded overflow-auto`}
          >
            {isLoadingSubject ? (
              <div className="flex gap-x-[10px] p-5 gap-y-[30px] rounded bg-container-background flex-wrap justify-center items-center text-over-primary-background">
                {Array(numberOfSkeletonCards)
                  .fill(0)
                  .map((_, index) => (
                    <GridCardSkeleton key={index} />
                  ))}
              </div>
            ) : null}
            {Object.keys(sortedGrids ?? {})?.map(course => (
              <div
                key={course}
                className="rounded bg-container-background border border-brd-primary h-[40%] w-full"
              >
                <h3 className="text-lg h-[43px] flex justify-center items-center p-[5px] rounded-t-[20px] bg-secondary-container-background w-full font-bold  text-center capitalize text-over-primary-background">
                  {course}
                </h3>

                <div className="flex items-center justify-center flex-wrap  p-5 gap-x-[10px] gap-y-[30px]">
                  {!isLoadingSubject
                    ? sortedGrids[course]?.map(grid => {
                        const index = globalIndex++
                        return (
                          <GridCard
                            gridId={grid?.grid.id}
                            removeGrid={removeGrid}
                            key={index}
                            currentGridIndex={currentGridIndex}
                            answer={answer?.correct_answer[index]}
                            active={
                              grid?.grid.choice !== null
                                ? grid?.grid.choice
                                : null
                            }
                            handleCurrentGrid={handleCurrentGrid}
                            handleCloseGridsModal={handleCloseGridsModal}
                            isTablet={isTablet}
                            index={grid.index}
                          />
                        )
                      })
                    : Array(10)
                        .fill(0)
                        .map((_, index) => <GridCardSkeleton key={index} />)}
                </div>
              </div>
            ))}
          </div>

          <div className="flex items-center mt-4 justify-center ">
            {create ? (
              <SubjectCreateButton
                allowHint={allowHint}
                setAllowHint={setAllowHint}
                onSuccess={onSuccessCreateSubject}
                subject={gridsFromSubject}
              />
            ) : answer || beginTimestamp === null ? (
              <Button
                isLoading={isSkippingSubject}
                onClick={() => handleNewSubjectWindow(answer ? 'new' : 'skip')}
                className="h-8 w-[175px] xl:flex hidden bg-btn-primary"
              >
                {answer
                  ? 'Simulare nouă'
                  : beginTimestamp === null
                    ? 'Altă simulare'
                    : 'Renunță'}
              </Button>
            ) : (
              ''
            )}
          </div>
        </>
      )}
    </div>
  )
}

export default GridsNavigation
